import { execFile } from 'node:child_process';
import { promisify } from 'node:util';
import { bridgeAgentPathEnv } from '../../acp/clients/bridge-agent-path.js';
import { formatCommandOutput } from '../format-command-output.js';

const execFileAsync = promisify(execFile);

export async function runNpmGlobalInstall(
  packageName: string,
  env: NodeJS.ProcessEnv,
  timeoutMs = 300_000
): Promise<string> {
  const { stdout, stderr } = await execFileAsync('npm', ['install', '-g', packageName], {
    timeout: timeoutMs,
    env: bridgeAgentPathEnv(env),
    maxBuffer: 10 * 1024 * 1024,
  });
  return formatCommandOutput(stdout, stderr);
}
